export default __webpack_public_path__ + "static/media/family-first-landing.d2825e6e.png";